const placeholderSign = Symbol("placeholder");

export { placeholderSign };
//# sourceMappingURL=private.mjs.map
